<template>
    <div class="content-inner">
        <x-panel margin>
            <div slot="title">Call Reports</div>
            <div slot="extra" :class="`d-flex justify-content-end`">
                <el-input
                    v-model="listFilters.search"
                    placeholder="Enter Search..."
                    clearable
                    type="tel"
                    style="width: 400px;"
                    class="filter-item mr-2"
                    @keyup.enter.native="handleFilter"
                    @clear="handleFilter"
                />
                <el-select v-model="listFilters.assigned" placeholder="Assigned Status" clearable
                           class="filter-item mr-2">
                    <el-option
                        v-for="(status, index) in assignedOptions"
                        :key="index"
                        :label="status.text"
                        :value="status.value"
                        @change="handleFilter"
                        @clear="handleFilter"
                    />
                </el-select>
                <el-select v-model="listFilters.ext" placeholder="Ext" clearable remote class="filter-item mr-2">
                    <el-option
                        v-for="(extention, index) in formatedExtentions"
                        :key="index"
                        :label="extention.text"
                        :value="extention.value"
                        @change="handleFilter"
                        @clear="handleFilter"
                    />
                </el-select>
                <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
                    Search
                </el-button>
            </div>
        </x-panel>
        <el-table
            :data="collection.data"
            style="width: 100%"
            v-loading="listLoading"
            fit
            :key="listLoading"
            ref="filterTable"
            row-key="id"
            border
            default-expand-all
        >
            <el-table-column prop="call_time" label="Call Time"></el-table-column>
            <el-table-column prop="caller_id" label="From"></el-table-column>
            <el-table-column prop="destination" label="To"></el-table-column>
            <el-table-column prop="reason" label="Notes"></el-table-column>
            <el-table-column prop="talking" label="Talking" width="100"></el-table-column>
            <el-table-column prop="totals" label="Call Total" width="100"></el-table-column>
            <el-table-column fixed="right" label="Operations" width="350">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.play"
                        type="success"
                        @click="handleDownload(scope.row, scope.row.id)"
                        round
                        icon="el-icon-download"
                        size="small"
                    >
                        Download
                    </el-button>
                    <el-button
                        v-if="scope.row.play"
                        type="success"
                        @click="handlePlay(scope.row, scope.row.id)"
                        round
                        icon="el-icon-circle-play"
                        size="small"
                    >
                        Play
                    </el-button>
                    <el-button
                        v-if="scope.row.application_id == null && scope.row.chain_id == null"
                        type="success"
                        @click="handleAssign(scope.$index, scope.row.id)"
                        round
                        icon="el-icon-paperclip"
                        size="small"
                    >
                        Assign
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="collection.total > 0"
            :total="collection.total"
            :page.sync="collection.current_page"
            :limit.sync="collection.per_page"
            @pagination="getCollection"
        />

        <x-modal width="600" @close="handlePlayerClose" v-if="player.visible == true" :footer="false">
            <div slot="title" :class="`truncate`">
                {{ player.selectedRecording.caller_id }} > {{ player.selectedRecording.destination }}
            </div>
            <div slot="body" class="modal-body"
                 v-loading="loadingAudio"
                 element-loading-text="Fetching recording..."
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(255, 255, 255, 0.8)"
            >
                <vue-audio
                    v-if="loadingAudio == false"
                    :autoplay="player.autoplay"
                    :formats="player.formats"
                    :src="player.src"
                    :key="player.id"
                    :preload="player.preload"
                    :xhrWithCredentials="player.credentials"
                    :html5="player.html5"
                ></vue-audio>
            </div>

        </x-modal>
        <x-modal
            width="600"
            @close="handleAssignModalClose"
            @cancel="handleAssignModalClose"
            @ok="handleAssignComplete"
            v-if="assignModal.visible == true"
        >
            <div slot="title" :class="`truncate`">
                Assign to Application
            </div>
            <div>
                <el-select
                    v-model="assignModal.applicationId"
                    class="w-100"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :loading="loading"
                    :remote-method="getApplications"
                    placeholder="Search Application"
                >
                    <el-option
                        v-for="item in applications"
                        :key="item.id"
                        :label="`APPLICATION ${item.ref_id} ${item.customer ? item.customer.full_name : ''}`"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </div>
        </x-modal>
    </div>
</template>
<script>
import Pagination from "@shared/components/pagination"

export default {
    name: "TenantCallReports",
    components: {Pagination},
    props: {},
    data() {
        return {
            collection: {},
            inqueue: 0,
            search: "",
            listLoading: true,
            loadingAudio: true,
            loading: false,
            listFilters: {
                search: "",
                ext: "",
                assigned: null
            },
            assignedOptions: [
                {
                    text: "Assigned Only",
                    value: "assigned"
                },
                {
                    text: "Unassigned Only",
                    value: "unassigned"
                }
            ],
            extentions: null,
            listLimit: 10,
            applications: [],
            player: {
                selectedRecording: null,
                autoplay: true,
                formats: [],
                preload: false,
                credentials: true,
                html5: true,
                id: 0,
                src: "",
                visible: false,
                title: ""
            },
            assignModal: {
                visible: false,
                callId: null,
                applicationId: null,
                index: null
            }
        }
    },
    mounted() {
        this.loadAgentExtentions()
        this.$tenant.get(`/api/3cx/call-reports`).then(res => {
            this.setData(res)
        }).catch(err => {
            err.output()
        });
    },
    computed: {
        formatedExtentions() {
            if (!this.extentions) return
            return this.extentions.map(extention => ({text: extention.name, value: parseInt(extention.ext)}))
        }
    },
    methods: {
        async loadAgentExtentions() {
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await this.$master.get(`/api/call-extentions/${Ambition.getGlobal("tenant.tenantId")}`)
                    resolve(res.data)
                    this.extentions = res.data
                } catch (Err) {
                    reject(Err)
                }
            })
        },
        setData(res) {
            this.$set(this.$data, "collection", res.data.collection)
            this.listLoading = false
            this.$bar.finish()
        },
        clearFilter() {
            this.$refs.filterTable.clearFilter()
        },
        handleFilter() {
            let collection = this.collection
            let event = {
                page: 1,
                limit: collection.per_page
            }
            this.getCollection(event)
        },
        handleAssign(index, id) {
            this.assignModal = {
                visible: true,
                callId: id,
                index
            }
        },
        handleAssignModalClose() {
            this.assignModal = {
                visible: false,
                callId: null,
                applicationId: null,
                index: null
            }
        },
        handleAssignComplete() {
            this.$tenant
                .post(
                    `/api/3cx/call-reports/assign/${this.assignModal.callId}`,
                    {
                        application_id: this.assignModal.applicationId
                    }
                )
                .then(res => {
                    this.collection.data[this.assignModal.index].application_id = res.data.call.application_id
                    this.handleAssignModalClose()
                    this.$message({
                        message: "Call entry assigned",
                        type: "success"
                    })
                })
                .catch(err => {
                    this.handleAssignModalClose()
                    this.$message({
                        message: "Unable to assign call entry",
                        type: "error"
                    })
                })
        },
        handleDownload(index, id) {
            this.$tenant
                .post(`/api/3cx/call-reports/download/${id}`)
                .then(res => {
                    let link = document.createElement("a")
                    link.href = res.data
                    link.download = `${index.filename}.mp3`
                    link.click()
                    this.$message({
                        message: "Call recording downloading",
                        type: "success"
                    })
                })
                .catch(err => {
                    this.$message({
                        message: "Recording Not Available, please try again later.",
                        type: "error"
                    })
                })
        },
        handlePlay(index, id) {
            this.player.visible = true
            this.player.selectedRecording = index
            this.$tenant
                .post(`/api/3cx/call-reports/play/${id}`)
                .then(res => {
                    this.player.id = id
                    this.player.src = res.data.file
                    this.loadingAudio = false
                })
                .catch(err => {
                    this.player.visible = false;
                    this.$message({
                        message: "Recording Not Available, please try again later.",
                        type: "error"
                    })
                })
        },
        handlePlayerClose() {
            this.player.visible = false
        },
        getCollection(event) {
            this.$bar.start()
            this.$tenant
                .get(`/api/3cx/call-reports?page=${event.page}&per_page=${event.limit}&${this.$serialize(this.listFilters)}`)
                .then(res => {
                    this.$set(this.$data, "collection", res.data.collection)
                    this.listLoading = false
                    this.$bar.finish()
                })
        },
        getApplications(query) {
            this.loading = true
            axios.get(`/api/v3/applications/search?q=${query}`).then(res => {
                this.loading = false
                this.applications = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-body {
    min-height: 200px;
    margin: 0;
    padding: 0;
    width: 100%;
    -ms-overflow-style: none; // IE 10+
    overflow: -moz-scrollbars-none; // Firefox
    &::-webkit-scrollbar {
        display: none; // Safari and Chrome
    }
}

.filter-container {
    margin-bottom: 1.5rem;
}

.truncate {
    max-width: 450px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.vueAudioBetter {
    background-image: none !important;
    box-shadow: none !important;
    background-color: #ffffff !important;

    .total {
        justify-content: center;

        span:nth-child(2) {
            display: none;
        }
    }

    .icon-speed-1,
    .icon-subtract_fill,
    .icon-roundaddfill {
        display: none !important;
    }

    .operatorButton span {
        cursor: pointer;
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

tr[class^="el-table__row el-table__row--level-"] {
    background-color: #d2d9ff !important;

    &.hover-row {
        background-color: #d2d9ff !important;
    }
}

.el-table__row--level-0 {
    background-color: #e3e7fb !important;

    &.hover-row {
        background-color: #e3e7fb !important;
    }
}
</style>
